import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { webSocketService } from '@hooks/useWebSocket';

/**
 * G8 — When the BFF broadcasts `plan.upgraded` / `plan.downgraded` /
 * `plan.cancelled` / `plan.change_requested` over Socket.IO, invalidate
 * the tenant's plan queries so the UI reflects the new state within
 * seconds. Drops in next to any plan-aware view.
 */
export function usePlanWebSocketSync(tenantId: string | null | undefined) {
  const qc = useQueryClient();

  useEffect(() => {
    if (!tenantId) return;
    const invalidate = () => {
      qc.invalidateQueries({ queryKey: ['plan'] });
    };
    const unsubs = [
      webSocketService.subscribe('plan.upgraded', invalidate),
      webSocketService.subscribe('plan.downgraded', invalidate),
      webSocketService.subscribe('plan.cancelled', invalidate),
      webSocketService.subscribe('plan.change_requested', invalidate),
    ];
    return () => {
      unsubs.forEach((fn) => {
        if (typeof fn === 'function') fn();
      });
    };
  }, [tenantId, qc]);
}
